// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___itv-4","touchable":"style__touchable___14mwM","scrollView":"style__scrollView___3T6Ts"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/canvas/ui/components/horizontal-bar/style.css
// module id = 1359
// module chunks = 0